<lx-side-panel size="large" [autoFocus]="true" [visible]="visible" (hiddenPanel)="hiddenPanel.emit()" data-qa="gallery_sidePanel" [spacing]="false">
  <p-galleria [value]="images" [circular]="true" [showItemNavigators]="validImages.length > 1" [showThumbnails]="false" data-qa="gallery">
    <ng-template pTemplate="item" let-item>
      <lx-image class="side-panel-gallery__image" [image]="item" [fallbackImage]="fallbackImage" [width]="480" [height]="320" alt="Gallery image" />
    </ng-template>
  </p-galleria>

  <div class="side-panel-gallery">
    <ng-content></ng-content>
  </div>
</lx-side-panel>
